import React from "react";
import { cn } from "utils";

const Card = React.forwardRef(({
    title,
    count,
    icon,
    cardClassName,
    isImage = true,
    onClick,
    isActive = false,
}, ref) => {

    return (
        <div className="col-lg-3">
            <div
                ref={ref}
                onClick={onClick}
                className={cn('border-gray cursor-pointer h-100 rounded-4 p-3 py-4 d-flex justify-content-between align-items-center', cardClassName)}
                style={isActive ? { border: '2px solid #f97316', background: '#fff7ed' } : {}}
            >
                <div>
                    <h3 className='company-title fs-6'>{title}</h3>
                    {count != null && count !== '' ? <h2 className='number-title mb-0'>{count}</h2> : ""}
                </div>
                <div>
                    {isImage ? (
                        <img src={icon} alt="company" />
                    ) : <>{icon}</>}
                </div>
            </div>
        </div>
    )
})

Card.displayName = "Card";

export default Card;